import type { ShapeData } from '@/lib/shapes/types/shape-data'

/**
 * The highest fractional index among the spread's top-level shapes, or undefined when none has
 * one. A template is stacked above this.
 *
 * Not "the index of the topmost shape in the layer order": an element that came from a legacy
 * spread can have no index at all, and it sorts above indexed ones, so the last shape in the order
 * can be one with nothing to stack above. A group's children are skipped: their indexes only order
 * them inside the group.
 */
export function topFractionalIndex(shapes: readonly ShapeData[]): string | undefined {
  let top: string | undefined

  for (const shape of shapes) {
    const index = shape.fractionalIndex

    if (shape.parentGroupId || !index) continue
    if (top === undefined || index > top) top = index
  }

  return top
}
